import { UserInformationResponse } from '@/types/service-response'

export class CurrentUser {
  private constructor (
    readonly id: number,
    readonly givenName: string,
    readonly familyName: string,
    readonly isBoarder: boolean,
    readonly isStaff: boolean,
    readonly staffRoleList: any,
    readonly boarderList: any,
    readonly tenant:any,
    readonly phoneNumbers: any,
    readonly loginName: any
  ) {}

  get fullName (): string {
    return `${this.givenName} ${this.familyName}`
  }

  get getBoarder (): any {
    return this.boarderList.length > 0 ?  this.boarderList[0] : null
  }

  get redirectAddress (): string|null {
    let table: any = {
      'stares-plus': 'https://staresplus.pozrimenu.sk/cp',
      'nortomlc': 'https://mdlc.pozrimenu.sk/cp'
    }

    let code = this.tenant.code

    return table[code] ?? null
  }

  static createFromUserInformationResponse (responseData: UserInformationResponse): CurrentUser {
    return new CurrentUser(
      responseData.id,
      responseData.givenName,
      responseData.familyName,
      responseData.isBoarder,
      responseData.isStaff,
      responseData.staffRoleList,
      responseData.boarderList,
      responseData.tenant,
      responseData.phoneNumbers,
      responseData.loginName

    )
  }
}
